import request from "../utils/request";

// Function to handle user login
export const login = async (email, password) => {
  try {
    const response = await request.post("/auth/login", { email, password });
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Throw error to be handled by the caller
  }
};

// Function to handle user registration
export const register = async (displayName, email, password) => {
  try {
    const response = await request.post("/auth/signup", {
      displayName,
      email,
      password,
    });
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Throw error to be handled by the caller
  }
};

// Function to handle user logout
export const logout = async () => {
  try {
    const response = await request.post("/auth/logout");
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Throw error to be handled by the caller
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await request.post("/auth/forgot-password", { email });
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Throw error to be handled by the caller
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await request.post("/auth/reset-password", {
      token,
      newPassword,
    });
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Throw error to be handled by the caller
  }
};

export const loginWithGoogle = () => {
  window.location.href = "https://echovault-backend.onrender.com/auth/google";
};